<template>
  <div>
    <header class="header-static">
      <a
        class="open-modal close-button"
        :href="modelValue.closeButtonUrl + '#' + modelValue.externalPolicyNumber"
      >
        <span class="icon-cross" />
      </a>
    </header>
    <div v-cloak ref="changeFrequency" class="small-12 medium-12 large-8">
      <h1 data-change-frequency-header v-html="modelValue.headerTitleText" />
      <div class="row payment-term-asset">
        <div class="column medium-1 small-2">
          <div
            :class="modelValue.iconCssClass"
            class="icon-large"
            data-change-frequency-asset-icon
          />
        </div>
        <div class="column medium-11 small-10">
          <h4
            class="payment-term-asset-header"
            data-change-frequency-asset-title
            v-html="modelValue.policyTitleText"
          />
          <div data-change-frequency-asset-text v-html="modelValue.policyAssetText" />
        </div>
      </div>
      <div v-if="modelValue.requireBSSignupBoolean" data-change-frequency-BS>
        <p data-change-frequency-BS-info v-html="modelValue.bsSignup.informationString" />
        <h4 data-change-frequency-BS-benefit-label v-html="modelValue.bsSignup.benefitLabel" />
        <p data-change-frequency-BS-benefit-text v-html="modelValue.bsSignup.benefitText" />
        <h4 data-change-frequency-BS-signup v-html="modelValue.bsSignup.signupLabel" />
        <betalings-service v-model="termChanges.accountDetails" class="payment-term-bs medium-6" />
        <p
          v-if="modelValue.bsSignup.remarksText"
          data-change-frequency-BS-signup-remarks
          v-html="modelValue.bsSignup.remarksText"
        />
      </div>
      <article>
        <h4 data-change-frequency-term-option-header v-html="modelValue.termOptions.headerText" />
        <fieldset class="radio-inline" name="PaymentTermSelect">
          <div
            v-for="(option, index) in modelValue.termOptions.options"
            :key="'frequency-radio-' + index"
          >
            <Field
              :rules="{
                required: termChanges.selectedTerm === modelValue.termOptions.originalTermKey
              }"
              :label="'Betalingsfrekvens'"
              :id="'term-' + index"
              name="PaymentTermSelect"
              v-model="termChanges.selectedTerm"
              type="radio"
              :value="option.key"
              data-change-frequency-term-option-radio
              @click="selectedTerm(index)"
            />
            <label
              :for="'term-' + index"
              data-change-frequency-term-option-label
              v-html="option.optionText"
            />
          </div>
          <ValidationError
            name="PaymentTermSelect"
            :overrides="{ required: modelValue.validationErrorModel.text }"
          />
        </fieldset>
        <p
          v-if="modelValue.termOptions.remarksText"
          data-change-frequency-term-option-remarks
          v-html="modelValue.termOptions.remarksText"
        />
      </article>
      <article>
        <h4
          data-change-frequency-change-option-header
          v-html="modelValue.changeOptions.headerText"
        />
        <fieldset class="radio-inline">
          <div
            v-for="(option, index) in modelValue.changeOptions.options"
            :key="'frequency-radio-' + index"
          >
            <Field
              :id="'period-' + index"
              v-model="termChanges.selectedPeriod"
              name="frequency-radio"
              type="radio"
              :value="option.key"
              data-change-frequency-change-option-radio
            />
            <label
              :for="'period-' + index"
              data-change-frequency-change-option-label
              v-html="option.optionText"
            />
          </div>
        </fieldset>
      </article>
      <article>
        <h4 data-change-frequency-contact-label v-html="modelValue.contactInformation.label" />
        <p data-change-frequency-contact-text v-html="modelValue.contactInformation.contactText" />
        <div class="payment-term-contact-info">
          <div
            data-change-frequency-contact-email
            v-html="modelValue.contactInformation.emailText"
          />
          <div
            data-change-frequency-contact-phone
            v-html="modelValue.contactInformation.phoneText"
          />
        </div>
        <p
          data-change-frequency-contact-info-text
          @click="checkElmOnClick($event)"
          v-html="modelValue.contactInformation.informationLinkText"
        />
      </article>
      <div class="row">
        <div class="columns medium-5 small-12">
          <button
            class="button large secondary"
            data-change-frequency-back-btn
            @click="onBackClick"
            v-html="modelValue.backLabel"
          />
        </div>
        <div class="columns medium-5 small-12">
          <button
            class="button large"
            data-change-frequency-submit-btn
            @click="completeChange(termChanges)"
            v-html="modelValue.submitLabel"
          />
        </div>
      </div>
    </div>
    <page-spinner :spinner-url-list="spinnerUrlList" />
  </div>
</template>
<script lang="ts">
import BetalingsService from '@/components/UI/BetalingsService.vue';
import { TermChanges } from '@/store/modules/interfaces/paymentFrequencyStoreState';
import PageSpinner from '@/components/UI/PageSpinner.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import { defineComponent, inject } from 'vue';
import { mapActions } from 'vuex';
import { FormContextKey } from 'vee-validate';

export default defineComponent({
  components: {
    BetalingsService,
    ValidationError,
    PageSpinner
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  data() {
    return {
      termChanges: {
        selectedTerm: this.modelValue.termOptions.originalTermKey,
        selectedPeriod: this.modelValue.changeOptions.originalTermKey,
        accountDetails: {
          accountNumber: null,
          registrationNumber: null
        },
        policyNumber: this.modelValue.policyNumberText
      } as TermChanges,
      spinnerUrlList: ['/api/changePaymentTerm/Submit'],
      termChoice: ''
    };
  },
  mounted() {
    if (this.modelValue.requireBSSignupBoolean) {
      this.dispatchTracking('FI-insurance');
    } else {
      this.dispatchTracking('BS-insurance');
    }
  },
  methods: {
    onBackClick(): void {
      if (this.modelValue.requireBSSignupBoolean) {
        this.dispatchTracking('return-FI');
        location.href = this.modelValue.backUrl;
      } else {
        this.dispatchTracking('return-BS');
      }
      location.href = this.modelValue.backUrl;
    },
    checkElmOnClick(event: any): void {
      const elm = event.target.localName;

      if (elm === 'a' && this.modelValue.requireBSSignupBoolean) {
        this.dispatchTracking('correction-FI');
      } else if (elm === 'a') {
        this.dispatchTracking('correction-BS');
      }
    },
    completeChange(payload: TermChanges): void {
      this.form.validate().then((result: any) => {
        if (result.valid) {
          this.sendChange(payload);
        }
      });
    },
    async sendChange(payload: TermChanges) {
      await this.sendFrequencyChange(payload).then(() => {
        if (this.modelValue.requireBSSignupBoolean) {
          this.dispatchTracking('completed-FI');
          this.register({
            event: 'payment-term-frequency-FI',
            id: 'paymentTerm',
            vm: this.termChoice
          });
        } else {
          this.dispatchTracking('completed-BS');
          this.register({
            event: 'payment-term-frequency-BS',
            id: 'paymentTerm',
            vm: this.termChoice
          });
        }
      });
    },
    selectedTerm(i: number): void {
      let term = this.modelValue.termOptions.options[i].optionText;
      this.termChoice = term;
    },
    dispatchTracking(label: string): void {
      this.register({
        event: `payment-term-${label}`,
        id: 'paymentTerm'
      });
    },
    ...mapActions('paymentFrequency', ['sendFrequencyChange']),
    ...mapActions('Events', ['register'])
  }
});
</script>
<style lang="scss" scoped></style>
@/components/Feature/Forms/BaseValidationError.vue
